import { get, post, put } from './client';

export function getUsers() {
  return get('/users');
}

export function saveUser({
  sub,
  ccaLicenses,
  isAgronomist,
  farmgate,
  ...user
}) {
  const payload = {
    ...user,
    organizations: ids(user.organizations),
    roles: ids(user.roles),
    farmgate: isAgronomist
      ? { ...farmgate, partners: ids(farmgate?.partners) }
      : undefined,
  };

  return sub ? updateUser(payload) : createUser(payload);
}

function createUser(user) {
  return post(`/users`, user);
}

function updateUser(user) {
  return put(`/users/${user.username}`, user);
}

function ids(collection) {
  return collection && collection.map(({ id }) => id);
}

export function deleteUser(user) {
  return post('/users/delete', user);
}

export function resetUserPassword(username, userStatus) {
  return post('/users/reset-password', { username, userStatus });
}

export function getGrowersForUser(username) {
  return get(`/users/growers?u=${encodeURIComponent(username)}`);
}

export function assignGrowersToUser(username, guids) {
  return post(`/users/${username}/growers`, guids);
}

export function getPermissionsPreview(params, options = {}) {
  return get('/permissions/preview', { params, ...options });
}
